import React, { useState, useEffect, useMemo } from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Grid,
  Card,
  CardContent,
  Chip,
  IconButton,
  Tooltip,
  LinearProgress,
  Divider,
  Avatar,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from '@material-ui/core'
import { isNil } from 'ramda'
import PreviousToursTable from './PreviousToursTable'
import styles from '../../../components/dashboard/Styles'
import {
  Close as CloseIcon,
  Person as PersonIcon,
  Event as EventIcon,
  LocationOn as LocationIcon,
  AttachMoney as MoneyIcon,
  Info as InfoIcon,
  Warning as WarningIcon,
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
  Edit as EditIcon,
  CheckCircle as ProcessIcon,
  Schedule as ScheduleIcon,
  Print as PrintIcon,
  Phone as PhoneIcon,
  Email as EmailIcon,
  Home as HomeIcon,
  Work as WorkIcon,
  Language as LanguageIcon,
  DirectionsCar as CarIcon,
  Security as SecurityIcon,
  GpsFixed as GpsIcon,
  SingleBed as SingleIcon,
  Cancel as CancelInsuranceIcon,
  Star as RewardsIcon,
  ContactPhone as EmergencyIcon,
  DirectionsBike as BikeIcon,
  Speed as SpeedIcon,
  Height as HeightIcon,
  //TrendingUp  as WeightIcon,
  Cake as BirthdayIcon,
  AccountCircle as BadgeIcon,
  School as ExperienceIcon,
  Business as BusinessIcon,
  Flag as FlagIcon,
  CreditCard as CreditCardIcon,
  Comment as CommentIcon
} from '@material-ui/icons'
import { tourApi } from '../api/tourApi'
import moment from 'moment'
import TourBookingFormButton from "../../../components/tourBookingForm";
// Importar el nuevo modal de procesamiento
import TourProcessingModal from './TourProcessingModal';
import TourDataService from '../../../services/tourDataService';
import tourPricingService from '../../../services/tourPricingService';
import TourCalculationService from '../../../services/TourCalculationService';
import RequestCompleteProfile from '../../../components/requestCompleteProfile';

const WeightIcon = () => (
  <svg 
    width="26" 
    height="26" 
    viewBox="0 0 26 26" 
    fill="black"
    style={{ marginRight: 8 }}
  >
    {/* Base trapezoidal del peso - relleno negro */}
    <path d="M4 8L8 20H16L20 8H4Z" fill="black"/>
    
    {/* Mango circular superior - relleno negro */}
    <circle cx="12" cy="6" r="2" fill="black"/>
    
    {/* Texto "kg" en el centro - color blanco para contraste */}
    <text x="12" y="16" textAnchor="middle" fontSize="8" fontWeight="bold" fill="white">
      kg
    </text>
    
    {/* Líneas de detalle para dar profundidad - color blanco */}
    <path d="M6 12H18" stroke="white" strokeWidth="0.6" opacity="0.8"/>
    <path d="M7 16H17" stroke="white" strokeWidth="0.6" opacity="0.8"/>
  </svg>
)

// Componente para mostrar tours anteriores
const PastImtbTours = ({ record }) => {
  console.log('PastImtbTours - record:', record)
  
  if (!record) {
    return <Typography variant="body2" style={{ padding: '10px', color: '#666' }}>No data available</Typography>
  }
  
  // Los datos de pastRentals ya están en el record
  const pastRentals = record.pastRentals || []
  
  console.log('PastImtbTours - pastRentals:', pastRentals)
  
  if (pastRentals.length === 0) {
    return <Typography variant="body2" style={{ padding: '10px', color: '#666' }}>No previous tours found</Typography>
  }
  
  return (
    <Paper style={{ marginTop: '10px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)', overflow: 'auto' }}>
      <Table size="small">
        <TableHead>
          <TableRow style={{ backgroundColor: '#ff9800' }}>
            <TableCell style={{ fontWeight: 'bold', color: 'white' }}>Tour</TableCell>
            <TableCell style={{ fontWeight: 'bold', color: 'white' }}>Cliente</TableCell>
            <TableCell style={{ fontWeight: 'bold', color: 'white' }}>Fecha Inicio</TableCell>
            <TableCell style={{ fontWeight: 'bold', color: 'white' }}>Fecha Fin</TableCell>
            <TableCell style={{ fontWeight: 'bold', color: 'white' }}>Vehículo</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {pastRentals.map((rental, index) => {
            console.log('Rendering rental:', rental)
            
            const tourName = rental && rental.booking && rental.booking.tour && rental.booking.tour.tour_name && rental.booking.tour.tour_name.tour_name_en 
              ? rental.booking.tour.tour_name.tour_name_en 
              : 'N/A'
            const startDate = rental && rental.booking && rental.booking.tour && rental.booking.tour.tour_start_date
              ? moment(rental.booking.tour.tour_start_date).format('DD/MM/YYYY')
              : 'N/A'
            const endDate = rental && rental.booking && rental.booking.tour && rental.booking.tour.tour_end_date
              ? moment(rental.booking.tour.tour_end_date).format('DD/MM/YYYY')
              : 'N/A'
            
            const clientName = rental && rental.booking && rental.booking.r_first_name && rental.booking.r_last_name
              ? `${rental.booking.r_first_name} ${rental.booking.r_last_name}`
              : 'N/A'
            
            const vehicleName = rental.vehicle && rental.vehicle.licence_plate
              ? rental.vehicle.model.model_name 
              : 'N/A'
      //console.log('vehicleName:', rental.vehicle)
      const vehicleId = rental.vehicle && rental.vehicle.licence_plate ? '(' + rental.vehicle.licence_plate + ')' : ''
            return (
              <TableRow 
                key={index}
                style={{ 
                  backgroundColor: index % 2 === 0 ? '#f9f9f9' : 'white'
                }}
              >
                <TableCell>{tourName}</TableCell>
                <TableCell>{clientName}</TableCell>
                <TableCell>{startDate}</TableCell>
                <TableCell>{endDate}</TableCell>
                <TableCell><strong>{vehicleName}</strong> {vehicleId}</TableCell>
              </TableRow>
            )
          })}
        </TableBody>
      </Table>
    </Paper>
  )
}


const TourDetailsDialog = ({ open, tourId, onClose, onProcess, onEdit, onCancel }) => {
  const [tour, setTour] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [showProcessingModal, setShowProcessingModal] = useState(false)
  const [calculatedTotals, setCalculatedTotals] = useState(null)

  const loadTourDetails = async () => {
    if (!open || !tourId) return
    
    setLoading(true)
    setError(null)
    
    try {
      const response = await tourApi.getTour(tourId)
      console.log('Tour Details Response:', response)
      if (response.success) {
        console.log('Tour Data:', response.data)
        console.log('Rental Info:', response.data.rental_info)
        console.log('Booking Info:', response.data.booking_info)
        console.log('Tour Info:', getNestedValue(response.data, 'booking_info.tour_info'))
        console.log('Calculated Pricing:', getNestedValue(response.data, 'rental_info.calculated_pricing'))
        console.log('Vehicle Models:', getNestedValue(response.data, 'rental_info.vehicle_models'))
        console.log('Time 1:', getNestedValue(response.data, 'rental_info.time_1'))
        console.log('Time 2:', getNestedValue(response.data, 'rental_info.time_2'))
        setTour(response.data)
        debugDates(response.data)
        
        // Calcular totales automáticamente si no están disponibles
        calculateAutomaticTotals(response.data)
      } else {
        setError('Failed to load tour details')
      }
    } catch (err) {
      console.error('Error loading tour details:', err)
      setError('Error loading tour details')
    } finally {
      setLoading(false)
    }
  }

  const calculateAutomaticTotals = (tourData) => {
    try {
      // Verificar si ya hay cálculos disponibles
      const existingCalculatedPricing = getNestedValue(tourData, 'rental_info.calculated_pricing')
      
      if (!existingCalculatedPricing || !existingCalculatedPricing.total1) {
        // Replicar exactamente la lógica del backend calculateDynamicTourPrice
        const booking = tourData.booking_info
        const rental = tourData.rental_info
        
        if (booking && rental) {
          // Calcular duración del tour usando las fechas del tour
          //const tourDuration = calculateTourDuration(booking, rental)

          const tourDuration = this.duration(rental.effective_start_date, rental.effective_end_date, true);

          // Inicializar estructura de precios dinámicos (igual que el backend)
          const dynamicPricing = {
            tour: 0,                    // Rider price (costo del tour)
            passenger: 0,               // Passenger price
            vehicle: 0,                 // Motorcycle - 1st Choice
            single: 0,                  // Single Room (habitación individual)
            cancellationInsurance: 0,   // Cancellation insurance (porcentaje dinámico)
            vipInsurance: 0,            // VIP insurance (precio dinámico por día)
            gps: 0,                     // GPS (por día)
            supplements: 0,             // Supplements (de charges)
            rewards: 0,                 // Rewards (descuento)
            discount: 0,                // Discount (descuento)
            subtotal: 0,                // Subtotal antes de descuentos
            total: 0                    // Total final
          }

          // 1. Precio del tour (Rider price - costo del tour)
          if (booking.tour && booking.tour.id) {
            // Usar precio estándar del tour (equivalente a tour_total en la BD)
            dynamicPricing.tour = 7565 // Precio estándar del tour
          }

          // 2. Precio del pasajero (Passenger)
          if (booking.p_first_name && booking.p_last_name) {
            // Usar precio estándar del pasajero (equivalente a tour_passenger en la BD)
            dynamicPricing.passenger = 3935 // Precio estándar del pasajero
          }

          // 3. Precio del vehículo específico (Motorcycle - 1st Choice)
          if (booking.model_1_id) {
            // Para el cálculo automático, usar precio estándar del vehículo
            // En el backend esto se obtiene de la tabla prices con tour_${upgrade_type}
            dynamicPricing.vehicle = 0 // La mayoría de vehículos no tienen costo adicional
          }

          // 4. Single Room (habitación individual)
          if (booking.r_single) {
            // Usar precio estándar del single room
            dynamicPricing.single = 500 // Precio estándar del single room
          }

          // 5. Seguro de cancelación (porcentaje dinámico de la suma de componentes)
          if (booking.r_cancel_insurance) {
            // Base para el cálculo: tour + passenger + vehicle + GPS + single
            const baseForCancellationInsurance = dynamicPricing.tour + 
              dynamicPricing.passenger + 
              dynamicPricing.vehicle + 
              dynamicPricing.gps + 
              dynamicPricing.single
            // 7.5% como en el backend
            dynamicPricing.cancellationInsurance = baseForCancellationInsurance * 0.075
          }

          // 6. Seguro VIP (precio dinámico por día)
          if (booking.r_insurance) {
            // Intentar obtener el precio VIP insurance del breakdown si está disponible
            const pricingBreakdown = getNestedValue(tourData, 'pricing.breakdown')
            let vipPricePerDay = 0
            
            if (pricingBreakdown && pricingBreakdown.vipInsurancePrice) {
              // Si el breakdown tiene el precio VIP, usarlo directamente
              dynamicPricing.vipInsurance = pricingBreakdown.vipInsurancePrice
            } else {
              // Si no está disponible en el breakdown, el precio debe obtenerse dinámicamente del backend
              // No usar valores hardcoded - debe calcularse desde la tabla Price
              dynamicPricing.vipInsurance = 0
              console.warn('VIP Insurance price no disponible en breakdown - debe obtenerse dinámicamente del backend')
            }
          }

          // 7. GPS (precio dinámico por día)
          if (booking.r_gps) {
            // Precio por día × duración del tour
            const gpsPricePerDay = 10 // Precio estándar GPS por día
            const gpsTotal = gpsPricePerDay * tourDuration
            // Redondear a 2 decimales para coincidir con el backend
            dynamicPricing.gps = Math.round(gpsTotal * 100) / 100
          }

          // 8. Suplementos (obtener de charges) - para el frontend usamos 0
          dynamicPricing.supplements = 0

          // 9. Rewards (descuento del booking)
          dynamicPricing.rewards = parseFloat(booking.rewards || 0)

          // 10. Discount (descuento del rental)
          dynamicPricing.discount = parseFloat(rental.discount || 0)

          // 11. Calcular subtotal (suma de componentes principales - sin seguros)
          dynamicPricing.subtotal = dynamicPricing.tour +
            dynamicPricing.passenger +
            dynamicPricing.vehicle +
            dynamicPricing.single +
            dynamicPricing.gps +
            dynamicPricing.supplements

          // 12. Calcular total final (subtotal + seguros - rewards - discount)
          dynamicPricing.total = dynamicPricing.subtotal +
            dynamicPricing.cancellationInsurance +
            dynamicPricing.vipInsurance -
            dynamicPricing.rewards -
            dynamicPricing.discount

          // Crear objeto de respuesta que coincida con el backend
          const calculatedTotals = {
            totalPrice: parseFloat(dynamicPricing.total.toFixed(2)),
            breakdown: dynamicPricing,
            tourDuration,
            calculationMethod: 'dynamic_complete_with_insurance',
            rentalId: rental.id
          }

          setCalculatedTotals(calculatedTotals)
          console.log('Cálculos automáticos realizados (coincidiendo con backend):', calculatedTotals)
        }
      }
    } catch (error) {
      console.error('Error calculando totales automáticos:', error)
    }
  }

  // Función auxiliar para calcular la duración del tour (replicando la lógica del backend)
  const calculateTourDuration = (booking, rental) => {
 
   /*  try {
      const tourId = booking.tour_id

      if (tourId === null || tourId === undefined || tourId === '') {
        // Si no hay tour_id, usar fechas del rental como fallback
        const startDate = rental.date_1
        const endDate = rental.date_2
        const duration = moment(endDate).diff(moment(startDate), 'days')
        return duration
      }

      // Para el frontend, usamos las fechas del booking como fallback
      // ya que no tenemos acceso directo a la tabla tours
      const startDate = booking.tour && booking.tour.effective_start_date ? 
        booking.tour.effective_start_date : rental.date_1
      const endDate = booking.tour && booking.tour.effective_end_date ? 
        booking.tour.effective_end_date : rental.date_2

      const duration = moment(endDate).diff(moment(startDate), 'days')
      return duration

    } catch (error) {
      console.error('Error calculando duración del tour:', error)
      return 1
    } */
  }

  useEffect(() => {
    loadTourDetails()
  }, [open, tourId])

  const getNestedValue = (obj, path) => {
    return path.split('.').reduce((current, key) => {
      return current && current[key] !== undefined ? current[key] : null
    }, obj)
  }

  const isAnotherPersonBooking = (record) => Number(getNestedValue(record, 'booking_info.is_for')) === 2

  const riderCountryName = (record) => {
    const bookingCountry = getNestedValue(record, 'booking_info.r_country_name')
    if (isAnotherPersonBooking(record)) return bookingCountry || ''
    return bookingCountry || getNestedValue(record, 'client_info.country_info.country') || ''
  }

  const riderNationalityName = (record) => {
    const bookingNationality = getNestedValue(record, 'booking_info.r_nationality_name')
      || getNestedValue(record, 'client_info.nationality_info.country')
    if (isAnotherPersonBooking(record)) {
      return bookingNationality && bookingNationality !== 'N/A' ? bookingNationality : 'N/A'
    }
    if (bookingNationality && bookingNationality !== 'N/A') return bookingNationality
    return getNestedValue(record, 'client_info.country_info.country') || 'N/A'
  }

  const getStatusInfo = (status) => {
    const statusNum = parseInt(status, 10)
    switch (statusNum) {
      case 0:
        return { text: 'Pending', bgColor: '#fff3cd', textColor: '#856404', icon: <WarningIcon /> }
      case 1:
        return { text: 'Processed', bgColor: '#d4edda', textColor: '#155724', icon: <CheckCircleIcon /> }
      case 3:
        return { text: 'Cancelled', bgColor: '#f8d7da', textColor: '#721c24', icon: <CancelIcon /> }
      default:
        return { text: 'Unknown', bgColor: '#e2e3e5', textColor: '#383d41', icon: <InfoIcon /> }
    }
  }

  const handleProcess = () => {
    console.log('Redirecting to enhanced tour processing with tour data:', tour)
    console.log('Tour ID being passed:', tour && tour.rental_info && tour.rental_info.id ? tour.rental_info.id : tourId)
    console.log('Rental info:', tour && tour.rental_info)
    console.log('Booking info:', tour && tour.booking_info)
    
    // Redirigir a la nueva vista TourProcessingEnhanced
    const rentalId = tour && tour.rental_info && tour.rental_info.id ? tour.rental_info.id : tourId
    window.location.href = `${window.location.origin}/#/process_tour_enhanced/${rentalId}`
  }

  const handleEdit = () => {
    onEdit && onEdit(tour)
  }

  const handleCancel = () => {
    onCancel && onCancel(tour)
  }

  const handlePrint = () => {
    if (!tour) return

    // Usar iframe oculto para imprimir (evita que Chrome muestre selector de color de la página principal)
    const iframe = document.createElement('iframe')
    iframe.setAttribute('style', 'position:absolute;width:0;height:0;border:0;overflow:hidden;clip:rect(0,0,0,0);')
    iframe.setAttribute('title', 'Print Tour Booking Form')
    document.body.appendChild(iframe)
    const printDoc = iframe.contentWindow || iframe.contentDocument
    if (!printDoc || !printDoc.document) {
      document.body.removeChild(iframe)
      return
    }

    // Preparar el contenido HTML para imprimir
    const printContent = `
      <!DOCTYPE html>
      <html>
                 <head>
           <title>Tour Booking Form - ID: ${tourId}</title>
           <meta charset="utf-8">
           <meta name="viewport" content="width=device-width, initial-scale=1.0, user-scalable=no">
           <meta name="format-detection" content="telephone=no">
           <meta name="format-detection" content="date=no">
           <meta name="format-detection" content="address=no">
           <meta name="format-detection" content="email=no">
           <meta name="robots" content="noindex, nofollow">
           <meta http-equiv="X-UA-Compatible" content="IE=edge">
          <style>
            /* Evitar que Chrome muestre selector de color al imprimir */
            input, input[type="color"], input[type="color"] *, [type="color"],
            .color-picker, [class*="color-picker"], [id*="color-picker"],
            [data-color-picker], [class*="color-selector"],
            [role="dialog"][aria-label*="color"], [role="dialog"][aria-label*="Color"],
            .hex-input, [class*="chrome-picker"], [class*="sketch-picker"] {
              display: none !important;
              visibility: hidden !important;
              position: absolute !important;
              left: -9999px !important;
              width: 0 !important;
              height: 0 !important;
              max-width: 0 !important;
              max-height: 0 !important;
              overflow: hidden !important;
              opacity: 0 !important;
              pointer-events: none !important;
              z-index: -9999 !important;
            }
            * { margin: 0; padding: 0; box-sizing: border-box; }
            body {
              font-family: Arial, sans-serif;
              background: white;
              color: #000;
              line-height: 1.25;
              padding: 8px;
              font-size: 11px;
            }
            .header {
              padding: 8px 0;
              margin-bottom: 8px;
              border-bottom: 1px solid #000;
              font-size: 11px;
            }
            .grid {
              display: grid;
              grid-template-columns: 1fr 1fr;
              gap: 12px;
            }
            .section {
              padding: 8px 0;
              margin-bottom: 8px;
              break-inside: avoid;
            }
            .section-title {
              font-weight: bold;
              font-size: 13px;
              margin-bottom: 6px;
            }
            .info-row {
              display: flex;
              margin-bottom: 4px;
              font-size: 11px;
            }
            .info-label {
              font-weight: bold;
              min-width: 110px;
              flex-shrink: 0;
              margin-right: 6px;
              font-size: 11px;
            }
            .info-value { flex: 1; font-size: 11px; }
            .icon-placeholder { display: none; }
            .total-price { font-weight: bold; font-size: 12px; }
            table {
              font-size: 10px;
              border-collapse: collapse;
              width: 100%;
            }
            th, td {
              padding: 4px 6px;
              border: 1px solid #000;
              text-align: left;
              font-size: 10px;
            }
            th { font-weight: bold; }
            @media print {
              input, input[type="color"], input[type="color"] *,
              .color-picker, [class*="color-picker"], [id*="color-picker"],
              [role="dialog"][aria-label*="color"], [role="dialog"][aria-label*="Color"] {
                display: none !important;
                visibility: hidden !important;
                width: 0 !important;
                height: 0 !important;
                position: absolute !important;
                left: -9999px !important;
              }
              body { padding: 6px; font-size: 11px; line-height: 1.2; }
              .header { padding: 6px 0; margin-bottom: 6px; font-size: 11px; }
              .grid { gap: 10px; }
              .section { margin-bottom: 6px; padding: 6px 0; }
              .info-row { margin-bottom: 3px; font-size: 10px; }
              .info-label { min-width: 105px; font-size: 10px; }
              .info-value { font-size: 10px; }
              .section-title { font-size: 12px; margin-bottom: 4px; }
              .total-price { font-size: 11px; }
              table, th, td { font-size: 10px; padding: 4px 5px; }
              @page { size: A4; margin: 0.6cm; }
            }
          </style>
                 </head>
         <body>
                       <script>
              (function() {
                function removeAllColorPickers() {
                  var selectors = 'input[type="color"], input[type="color"] *, [type="color"], .color-picker, [class*="color-picker"], [id*="color-picker"], [data-color-picker], [class*="color-selector"], [role="dialog"][aria-label*="color"], [role="dialog"][aria-label*="Color"], .hex-input, [class*="chrome-picker"], [class*="sketch-picker"]';
                  try {
                    document.querySelectorAll(selectors).forEach(function(el) { el.remove(); });
                    document.querySelectorAll('input').forEach(function(el) {
                      if (el.type === 'color') { el.remove(); }
                    });
                  } catch (e) {}
                }
                removeAllColorPickers();
                setTimeout(removeAllColorPickers, 50);
                setTimeout(removeAllColorPickers, 200);
                window.addEventListener('beforeprint', removeAllColorPickers);
                document.addEventListener('DOMContentLoaded', removeAllColorPickers);
                var obs = new MutationObserver(removeAllColorPickers);
                if (document.body) obs.observe(document.body, { childList: true, subtree: true });
              })();
            </script>
          <div class="header">
            TOUR BOOKING FORM | ID: ${tourId} | ${getStatusInfo(getNestedValue(tour, 'rental_info.status')).text} | Tour: ${getNestedValue(tour, 'booking_info.tour_info.tour_name') || 'N/A'} | Start: ${formatDate(getNestedValue(tour, 'booking_info.tour_info.tour_start_date'))} End: ${formatDate(getNestedValue(tour, 'booking_info.tour_info.tour_end_date'))} | ${getNestedValue(tour, 'booking_info.r_first_name')} ${getNestedValue(tour, 'booking_info.r_last_name')} | ${getNestedValue(tour, 'booking_info.r_home_phone') || 'N/A'} | Printed: ${new Date().toLocaleDateString()}
          </div>

          <div class="grid">
            <!-- Left Column -->
            <div>
              <!-- Tour Summary -->
              <div class="section">
                <div class="section-title">Tour Summary</div>
                <div class="info-row">
                  <span class="info-label">Tour Name:</span>
                  <span class="info-value">${getNestedValue(tour, 'booking_info.tour_info.tour_name')}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">P4M:</span>
                  <span class="info-value">${getNestedValue(tour, 'booking_info.p4m') ? 'Yes' : 'No'}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">Tour Start Date:</span>
                  <span class="info-value">${formatDate(getNestedValue(tour, 'booking_info.tour_info.tour_start_date'))}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">Rider:</span>
                  <span class="info-value">${getNestedValue(tour, 'booking_info.r_first_name') ? 
                    `${getNestedValue(tour, 'booking_info.r_first_name')} ${getNestedValue(tour, 'booking_info.r_last_name')}` : 
                    'No'}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">Passenger:</span>
                  <span class="info-value">${getNestedValue(tour, 'booking_info.p_first_name') ? 
                    `${getNestedValue(tour, 'booking_info.p_first_name')} ${getNestedValue(tour, 'booking_info.p_last_name')}` : 
                    'No'}</span>
                </div>
                ${getNestedValue(tour, 'booking_info.roommate') !== '' ? `
                <div class="info-row">
                  <span class="info-label">Roommate Name:</span>
                  <span class="info-value">${getNestedValue(tour, 'booking_info.roommate') || 'No'}</span>
                </div>
                ` : ''}
                <div class="info-row">
                  <span class="info-label">Motorcycle:</span>
                  <span class="info-value">${(() => {
                    const model1 = getNestedValue(tour, 'rental_info.vehicle_models.model1.name') || getNestedValue(tour, 'booking_info.vehicle_model_1') || 'N/A'
                    const model2 = getNestedValue(tour, 'rental_info.vehicle_models.model2.name') || getNestedValue(tour, 'booking_info.vehicle_model_2') || 'N/A'
                    return `${model1} (first choice) - ${model2} (second choice)`
                  })()}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">GPS:</span>
                  <span class="info-value">${getNestedValue(tour, 'booking_info.r_gps') ? 'Yes' : 'No'}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">Room Type:</span>
                  <span class="info-value">${getNestedValue(tour, 'booking_info.r_single') ? 'Single' : 'Double'}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">Cancel Insurance:</span>
                  <span class="info-value">${getNestedValue(tour, 'booking_info.r_cancel_insurance') ? 'Yes' : 'No'}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">VIP Insurance:</span>
                  <span class="info-value">${getNestedValue(tour, 'booking_info.r_insurance') ? 'Yes' : 'No'}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">IMT Rewards:</span>
                  <span class="info-value">${getNestedValue(tour, 'booking_info.rewards') || 0} points</span>
                </div>
              </div>

              <!-- Riding Experience -->
              <div class="section">
                <div class="section-title">Riding Experience</div>
                <div class="info-row">
                  <span class="info-label">Years of Riding:</span>
                  <span class="info-value">${calculateExperienceYears(getNestedValue(tour, 'booking_info.r_experience_years'))} years</span>
                </div>
                <div class="info-row">
                  <span class="info-label">Riding Last Year:</span>
                  <span class="info-value">${getNestedValue(tour, 'booking_info.r_experience_past_year') || 'N/A'} ${getNestedValue(tour, 'booking_info.r_experience_past_year_unit') === '1' ? 'km' : 'miles'}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">Average Ride Distance:</span>
                  <span class="info-value">${getNestedValue(tour, 'booking_info.r_experience_ride_distance') || 'N/A'} ${getNestedValue(tour, 'booking_info.r_experience_ride_distance_unit') === '1' ? 'km' : 'miles'}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">Riding Experience:</span>
                  <span class="info-value">${getRidingExperience(getNestedValue(tour, 'booking_info'), 'r')}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">Motorcycle(s) Owned:</span>
                  <span class="info-value">${getNestedValue(tour, 'booking_info.r_own_models') || 'N/A'}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">How Did You Find About Us?:</span>
                  <span class="info-value">${getNestedValue(tour, 'client_info.referral_info.name') || 'N/A'}</span>
                </div>
              </div>

              <!-- Rider Information -->
              <div class="section">
                <div class="section-title">Rider Information</div>
                <div class="info-row">
                  <span class="info-label">Name:</span>
                  <span class="info-value">${getNestedValue(tour, 'booking_info.r_first_name') || ''} ${getNestedValue(tour, 'booking_info.r_last_name') || ''}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">Email:</span>
                  <span class="info-value">${getNestedValue(tour, 'booking_info.r_email') || 'N/A'}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">Phone Number:</span>
                  <span class="info-value">Home ${getNestedValue(tour, 'booking_info.r_home_phone') || 'N/A'} - Work ${getNestedValue(tour, 'booking_info.r_work_phone') || 'N/A'}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">Date of Birth:</span>
                  <span class="info-value">${formatBirthDate(getNestedValue(tour, 'booking_info.r_birthday'))}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">Address:</span>
                  <span class="info-value">${getNestedValue(tour, 'booking_info.r_address') || ''}, ${getNestedValue(tour, 'booking_info.r_zip') || ''}, ${getNestedValue(tour, 'booking_info.r_city') || ''}, ${getNestedValue(tour, 'booking_info.r_state_province') || ''}, ${riderCountryName(tour)}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">Nationality:</span>
                  <span class="info-value">${riderNationalityName(tour)}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">Occupation:</span>
                  <span class="info-value">${getNestedValue(tour, 'booking_info.r_occupation') || 'N/A'}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">Languages Spoken:</span>
                  <span class="info-value">${getLanguages(getNestedValue(tour, 'booking_info'), 'r')}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">Passport/ID:</span>
                  <span class="info-value">${getNestedValue(tour, 'booking_info.r_passport') || 'N/A'}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">Driver's License:</span>
                  <span class="info-value">${getNestedValue(tour, 'booking_info.r_license') || 'N/A'}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">Height:</span>
                  <span class="info-value">${getNestedValue(tour, 'booking_info.r_height') || 'N/A'} ${getHeightUnit(getNestedValue(tour, 'booking_info.r_height_unit'))}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">Weight:</span>
                  <span class="info-value">${getNestedValue(tour, 'booking_info.r_weight') || 'N/A'} ${getWeightUnit(getNestedValue(tour, 'booking_info.r_weight_unit'))}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">T-shirt Size:</span>
                  <span class="info-value">${getShirtSize(getNestedValue(tour, 'booking_info.r_shirt'))}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">Allergy/Special Diet:</span>
                  <span class="info-value">${getNestedValue(tour, 'booking_info.r_allergy_special_diet') || 'N/A'}</span>
                </div>
                ${getNestedValue(tour, 'booking_info.nickname') ? `
                <div class="info-row">
                  <span class="info-label">Nickname:</span>
                  <span class="info-value">${getNestedValue(tour, 'booking_info.nickname')}</span>
                </div>
                ` : ''}
              </div>

              <!-- Emergency Contact -->
              <div class="section">
                <div class="section-title">Emergency Contact</div>
                <div class="info-row">
                  <span class="info-label">Name:</span>
                  <span class="info-value">${getNestedValue(tour, 'booking_info.r_emergency_name') || 'N/A'}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">Relationship:</span>
                  <span class="info-value">${getNestedValue(tour, 'booking_info.r_emergency_relationship') || 'N/A'}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">Number:</span>
                  <span class="info-value">${getNestedValue(tour, 'booking_info.r_emergency_phone') || 'N/A'}</span>
                </div>
              </div>
            </div>

            <!-- Column 2 -->
            <div>
              <!-- Passenger Information (if exists) -->
              ${getNestedValue(tour, 'booking_info.p_first_name') ? `
              <div class="section">
                <div class="section-title">Passenger Information</div>
                <div class="info-row">
                  <span class="info-label">Name:</span>
                  <span class="info-value">${getNestedValue(tour, 'booking_info.p_first_name') || ''} ${getNestedValue(tour, 'booking_info.p_last_name') || ''}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">Email:</span>
                  <span class="info-value">${getNestedValue(tour, 'booking_info.p_email') || 'N/A'}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">Phone Number:</span>
                  <span class="info-value">Home ${getNestedValue(tour, 'booking_info.p_home_phone') || 'N/A'} - Work ${getNestedValue(tour, 'booking_info.p_work_phone') || 'N/A'}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">Date of Birth:</span>
                  <span class="info-value">${formatBirthDate(getNestedValue(tour, 'booking_info.p_birthday'))}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">Address:</span>
                  <span class="info-value">${getNestedValue(tour, 'booking_info.p_address') || ''}, ${getNestedValue(tour, 'booking_info.p_zip') || ''}, ${getNestedValue(tour, 'booking_info.p_city') || ''}, ${getNestedValue(tour, 'booking_info.p_state_province') || ''}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">Nationality:</span>
                  <span class="info-value">${isAnotherPersonBooking(tour) ? 'N/A' : (getNestedValue(tour, 'client_info.country_info.country') || 'N/A')}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">Occupation:</span>
                  <span class="info-value">${getNestedValue(tour, 'booking_info.p_occupation') || 'N/A'}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">Languages Spoken:</span>
                  <span class="info-value">${getLanguages(getNestedValue(tour, 'booking_info'), 'p')}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">Passport/ID:</span>
                  <span class="info-value">${getNestedValue(tour, 'booking_info.p_passport') || 'N/A'}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">Driver's License:</span>
                  <span class="info-value">N/A</span>
                </div>
                <div class="info-row">
                  <span class="info-label">Height:</span>
                  <span class="info-value">${getNestedValue(tour, 'booking_info.p_height') || 'N/A'} ${getHeightUnit(getNestedValue(tour, 'booking_info.p_height_unit'))}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">Weight:</span>
                  <span class="info-value">${getNestedValue(tour, 'booking_info.p_weight') || 'N/A'} ${getWeightUnit(getNestedValue(tour, 'booking_info.p_weight_unit'))}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">T-shirt Size:</span>
                  <span class="info-value">${getShirtSize(getNestedValue(tour, 'booking_info.p_shirt'))}</span>
                </div>
              </div>
              ` : ''}

              <!-- Tour Cost -->
              <div class="section">
                <div class="section-title">Tour Cost</div>
                ${(() => {
                  const calculatedPricing = getNestedValue(tour, 'rental_info.calculated_pricing')
                  const breakdown = getNestedValue(calculatedPricing, 'breakdown')
                  
                  if (calculatedPricing && calculatedPricing.total1 !== null && calculatedPricing.total1 !== undefined) {
                    return `
                      <div class="info-row">
                        <span class="info-label">Total Price (1st Choice):</span>
                        <span class="info-value total-price">${calculatedPricing.total1} €</span>
                      </div>
                      <div class="info-row">
                        <span class="info-label">Total Price (2nd Choice):</span>
                        <span class="info-value total-price">${calculatedPricing.total2} €</span>
                      </div>
                    `
                  } else {
                    return `
                      <div class="info-row">
                        <span class="info-label">Price for First Choice Bike:</span>
                        <span class="info-value">${getNestedValue(tour, 'rental_info.rental_price') || 0}.00 €</span>
                      </div>
                      <div class="info-row">
                        <span class="info-label">Price for Second Choice Bike:</span>
                        <span class="info-value">${getNestedValue(tour, 'rental_info.rental_price') || 0}.00 €</span>
                      </div>
                      <div class="info-row">
                        <span class="info-label">Tour Cost:</span>
                        <span class="info-value total-price">${getNestedValue(tour, 'rentalCost.total') || 0}.00 €</span>
                      </div>
                    `
                  }
                })()}
                
                <div class="info-row">
                  <span class="info-label">Credit Card:</span>
                  <span class="info-value">${(() => {
                    const clientData = getNestedValue(tour, 'clientData')
                    if (!clientData) return 'N/A'
                    
                    const cardType = clientData.card_type || 'N/A'
                    const cardNumber = clientData.card_number || 'N/A'
                    const cardExpiry = clientData.card_expiry || 'N/A'
                    const cardCvv = clientData.card_cvv || 'N/A'
                    
                    return `${cardType} - ${cardNumber} - ${cardExpiry} - ${cardCvv}`
                  })()}</span>
                </div>
                ${getNestedValue(tour, 'booking_info.r_comments') ? `
                <div class="info-row">
                  <span class="info-label">Comments:</span>
                  <span class="info-value">${getNestedValue(tour, 'booking_info.r_comments')}</span>
                </div>
                ` : ''}
                ${getNestedValue(tour, 'booking_info.r_allergy_special_diet') ? `
                <div class="info-row">
                  <span class="info-label">Allergy/Special Diet:</span>
                  <span class="info-value">${getNestedValue(tour, 'booking_info.r_allergy_special_diet')}</span>
                </div>
                ` : ''}
              </div>
            </div>
          </div>

          <!-- Previous Tours Section -->
          <div class="section">
            <div class="section-title">Previous Tours</div>
            ${(() => {
              const pastRentals = tour.pastRentals || []
              if (pastRentals.length === 0) {
                return '<div>No previous tours found</div>'
              }
              
              return `
                <table>
                  <thead>
                    <tr>
                      <th>Tour</th>
                      <th>Cliente</th>
                      <th>Inicio</th>
                      <th>Fin</th>
                      <th>Vehículo</th>
                    </tr>
                  </thead>
                  <tbody>
                    ${pastRentals.map((rental) => {
                      const tourName = rental && rental.booking && rental.booking.tour && rental.booking.tour.tour_name && rental.booking.tour.tour_name.tour_name_en 
                        ? rental.booking.tour.tour_name.tour_name_en 
                        : 'N/A'
                      const startDate = rental && rental.booking && rental.booking.tour && rental.booking.tour.tour_start_date
                        ? moment(rental.booking.tour.tour_start_date).format('DD/MM/YYYY')
                        : 'N/A'
                      const endDate = rental && rental.booking && rental.booking.tour && rental.booking.tour.tour_end_date
                        ? moment(rental.booking.tour.tour_end_date).format('DD/MM/YYYY')
                        : 'N/A'
                      const clientName = rental && rental.booking && rental.booking.r_first_name && rental.booking.r_last_name
                        ? `${rental.booking.r_first_name} ${rental.booking.r_last_name}`
                        : 'N/A'
                      const vehicleName = rental && rental.vehicle && rental.vehicle.length > 0 && rental.vehicle[0] && rental.vehicle[0].model && rental.vehicle[0].model.name 
                        ? rental.vehicle[0].model.name 
                        : 'N/A'
                      return `
                        <tr>
                          <td>${tourName}</td>
                          <td>${clientName}</td>
                          <td>${startDate}</td>
                          <td>${endDate}</td>
                          <td>${vehicleName}</td>
                        </tr>
                      `
                    }).join('')}
                  </tbody>
                </table>
              `
            })()}
          </div>
        </body>
      </html>
    `

    // Escribir el contenido en el iframe
    const doc = printDoc.document
    doc.open()
    doc.write(printContent)
    doc.close()

    const win = iframe.contentWindow || doc.defaultView
    const doPrint = () => {
      try {
        // Limpiar cualquier selector de color inyectado por Chrome antes de imprimir
        doc.querySelectorAll('input, input[type="color"], [type="color"], .color-picker, [class*="color-picker"], [id*="color-picker"], [data-color-picker]').forEach(el => { el.remove() })
      } catch (e) { /* ignorar */ }
      if (win && typeof win.print === 'function') win.print()
      setTimeout(() => {
        if (iframe.parentNode) document.body.removeChild(iframe)
      }, 1000)
    }

    if (iframe.contentWindow) {
      iframe.contentWindow.onload = () => {
        setTimeout(doPrint, 300)
      }
    } else {
      setTimeout(doPrint, 500)
    }
  }

  const formatDate = (dateString) => {
    console.log('formatDate input:', dateString)
    if (!dateString) {
      console.log('formatDate: no dateString provided')
      return 'N/A'
    }
    
    const momentDate = moment(dateString)
    if (!momentDate.isValid()) {
      console.log('formatDate: invalid date:', dateString)
      return 'Invalid date'
    }
    
    console.log('formatDate output:', momentDate.format('MMMM D, YYYY'))
    return momentDate.format('MMMM D, YYYY')
  }

  const formatBirthDate = (dateString) => {
    if (!dateString) return 'N/A'
    const date = moment(dateString)
    const age = moment().diff(date, 'years')
    return `${date.format('DD-MM-YYYY')} (${age} years)`
  }

  const getShirtSize = (size) => {
    const sizes = {
      1: 'S (EU) | XS (US)',
      2: 'M (EU) | S (US)',
      3: 'L (EU) | M (US)',
      4: 'XL (EU) | L (US)',
      5: 'XXL (EU) | XL (US)',
      6: 'XXXL (EU) | XXL (US)'
    }
    return sizes[size] || 'N/A'
  }

  const getLanguages = (booking, prefix = 'r') => {
    const languages = ['english', 'spanish', 'german', 'french', 'portuguese']
    const spokenLanguages = languages.filter(lang => booking[`${prefix}_${lang}`])
    return spokenLanguages.map(lang => lang.charAt(0).toUpperCase() + lang.slice(1)).join(', ')
  }

  const getRidingExperience = (booking, prefix = 'r') => {
    const experiences = ['street', 'sweepers', 'twisties', 'track', 'off_road']
    const ridingExp = experiences.filter(exp => booking[`${prefix}_${exp}`])
    return ridingExp.map(exp => exp.charAt(0).toUpperCase() + exp.slice(1)).join(', ')
  }

  const getHeightUnit = (unit) => {
    return unit === 1 || unit === '1' ? 'ft' : 'm'
  }

  const getWeightUnit = (unit) => {
    return unit === 1 || unit === '1' ? 'lbs' : 'kg'
  }

  const calculateExperienceYears = (experienceYears) => {
    const exp = parseInt(experienceYears, 10)
    if (isNaN(exp)) return 0
    return exp.toString().length === 4 ? (new Date().getFullYear()) - exp : exp
  }

  const InfoRow = ({ icon, label, value, color = '#666' }) => (
    <div style={{ display: 'flex', alignItems: 'center', marginBottom: 12 }}>
      <div style={{ display: 'flex', alignItems: 'center', minWidth: 140, marginRight: 12 }}>
        {icon && <span style={{ marginRight: 8, color: '#ff9800' }}>{icon}</span>}
        <Typography variant="body2" style={{ color: '#666', fontWeight: 500 }}>
          {label}:
        </Typography>
      </div>
      <Typography variant="body2" style={{ color, fontWeight: value === 'Yes' ? 'bold' : 'normal' }}>
        {value || 'N/A'}
      </Typography>
    </div>
  )

  const SectionCard = ({ title, icon, children, color = '#ff9800' }) => (
    <Card elevation={2} style={{ marginBottom: 16, borderRadius: 12 }}>
      <CardContent style={{ padding: 20 }}>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: 16 }}>
          <Avatar style={{ backgroundColor: color, marginRight: 12, width: 32, height: 32 }}>
            {icon}
          </Avatar>
          <Typography variant="h6" style={{ color, fontWeight: 'bold' }}>
            {title}
          </Typography>
        </div>
        {children}
      </CardContent>
    </Card>
  )

  const debugDates = (tour) => {
    if (!tour) return
    
    console.log('=== DEBUG DATES ===')
    console.log('time_1:', getNestedValue(tour, 'rental_info.time_1'))
    console.log('time_2:', getNestedValue(tour, 'rental_info.time_2'))
    console.log('tour_start_date:', getNestedValue(tour, 'booking_info.tour_info.tour_start_date'))
    console.log('tour_end_date:', getNestedValue(tour, 'booking_info.tour_info.tour_end_date'))
    
    const time1 = getNestedValue(tour, 'rental_info.time_1')
    const time2 = getNestedValue(tour, 'rental_info.time_2')
    
    if (time1) {
      console.log('time_1 moment:', moment(time1))
      console.log('time_1 isValid:', moment(time1).isValid())
      console.log('time_1 format:', moment(time1).format('DD/MM/YYYY'))
    }
    
    if (time2) {
      console.log('time_2 moment:', moment(time2))
      console.log('time_2 isValid:', moment(time2).isValid())
      console.log('time_2 format:', moment(time2).format('DD/MM/YYYY'))
    }
    console.log('=== END DEBUG DATES ===')
  }

  if (!open) return null

  console.log('TourDetailsDialog - tour:', tour)
  var BookingId = getNestedValue(tour, 'booking_info.id')

  return (
    <React.Fragment>
      <Dialog 
        open={open} 
        onClose={onClose} 
        maxWidth="lg" 
        fullWidth 
        PaperProps={{ 
          style: { 
            borderRadius: 16, 
            maxHeight: '95vh',
            minHeight: '85vh',
            boxShadow: '0 8px 32px rgba(0,0,0,0.1)'
          } 
        }}
      >
      {/* Custom Header instead of DialogTitle */}
      <div style={{ 
        background: 'linear-gradient(135deg, #f57c00 0%, #ff9800 100%)', 
        color: 'white', 
        display: 'flex', 
        alignItems: 'center', 
        padding: '24px 32px',
        borderRadius: '16px 16px 0 0',
        position: 'relative',
        minHeight: '80px'
      }}>
        <div style={{ 
          display: 'grid',
          gridTemplateColumns: '1fr 2fr 1fr',
          gap: '20px',
          alignItems: 'center',
          height: '100%',
          width: '100%',
          padding: '0 20px'
        }}>
          {/* Left Side - Status and Tour Info */}
          <div style={{ 
            display: 'flex', 
            flexDirection: 'column',
            justifyContent: 'center', 
            alignItems: 'flex-start'
          }}>
            {(() => {
              const statusInfo = getStatusInfo(getNestedValue(tour, 'rental_info.status'))
              return (
                <div style={{ 
                  display: 'flex', 
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                  gap: '8px'
                }}>
                  <div style={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    textAlign: 'left',
                    justifyContent: 'flex-start',
                    background: 'rgba(255,255,255,0.2)', 
                    padding: '8px 16px', 
                    borderRadius: 20,
                    border: '1px solid rgba(255,255,255,0.3)'
                  }}>
                    <span style={{ marginRight: 8, fontSize: 20, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{statusInfo.icon}</span>
                    <Typography variant="h6" style={{ fontWeight: 'bold', fontSize: '16px' }}>
                      {statusInfo.text}
                    </Typography>
                  </div>
                  
                  {/* Tour Name */}
                  <div style={{ color: 'white', fontSize: '14px', fontWeight: 'bold' }}>
                    Tour Name: {getNestedValue(tour, 'booking_info.tour_info.tour_name') || 'N/A'}
                  </div>
                  
                  {/* Start Date and End Date */}
                  <div style={{ color: 'white', fontSize: '12px', opacity: 0.9 }}>
                    <div>Start Date: {(() => {
                      const startDate = getNestedValue(tour, 'booking_info.tour_info.tour_start_date') || getNestedValue(tour, 'rental_info.start_date')
                      console.log('Header Start Date - startDate:', startDate)
                      if (!startDate) return 'N/A'
                      
                      const momentDate = moment(startDate)
                      if (!momentDate.isValid()) {
                        console.log('Header Start Date - invalid date:', startDate)
                        return 'Invalid date'
                      }
                      
                      return momentDate.format('DD/MM/YYYY')
                    })()}</div>
                    <div>End Date: {(() => {
                      const endDate = getNestedValue(tour, 'booking_info.tour_info.tour_end_date') || getNestedValue(tour, 'rental_info.end_date')
                      console.log('Header End Date - endDate:', endDate)
                      if (!endDate) return 'N/A'
                      
                      const momentDate = moment(endDate)
                      if (!momentDate.isValid()) {
                        console.log('Header End Date - invalid date:', endDate)
                        return 'Invalid date'
                      }
                      
                      return momentDate.format('DD/MM/YYYY')
                    })()}</div>
                  </div>
                </div>
              )
            })()}
          </div>

          {/* Center - Title and ID */}
          <div style={{ 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center'
          }}>
            <div style={{ 
              display: 'flex', 
              alignItems: 'center',
              textAlign: 'center'
            }}>
              <ScheduleIcon style={{ marginRight: 16, fontSize: 32 }} />
              <div>
                <Typography variant="h4" style={{ fontWeight: 'bold', marginBottom: 4 }}>
                  TOUR BOOKING FORM
                </Typography>
                <Typography variant="subtitle1" style={{ opacity: 0.9, marginBottom: 8 }}>
                  ID: {tourId}
                </Typography>
                
                {/* Client Information in Header */}
                {tour && (
                  <div style={{ 
                    display: 'flex', 
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '4px',
                    marginTop: '8px'
                  }}>
                    <Typography variant="body1" style={{ 
                      fontWeight: 'bold', 
                      color: 'white',
                      fontSize: '16px'
                    }}>
                      {getNestedValue(tour, 'booking_info.r_first_name')} {getNestedValue(tour, 'booking_info.r_last_name')}
                    </Typography>
                 {/*    <Typography variant="body2" style={{ 
                      color: 'white',
                      opacity: 0.9,
                      fontSize: '14px'
                    }}>
                      {getNestedValue(tour, 'booking_info.r_email') || 'N/A'}
                    </Typography> */}
                    <Typography variant="body2" style={{ 
                      color: 'white',
                      opacity: 0.9,
                      fontSize: '14px'
                    }}>
                      {getNestedValue(tour, 'booking_info.r_home_phone') || 'N/A'}
                    </Typography>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Right Side - Action Buttons */}
          <div style={{ 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center'
          }}>
            <div style={{ 
              display: 'flex', 
              alignItems: 'center',
              gap: 8
            }}>
              {console.log('TourDetailsDialog - tourId que se pasa al TourBookingFormButton:', BookingId)}
              <TourBookingFormButton bookingId={BookingId} />
              <Tooltip title="Print Details">
                <IconButton style={{ color: 'white' }} onClick={handlePrint}>
                  <PrintIcon />
                </IconButton>
              </Tooltip>
              <IconButton onClick={onClose} style={{ color: 'white' }}>
                <CloseIcon />
              </IconButton>
            </div>
          </div>
        </div>
      </div>

      <DialogContent style={{ padding: 0 }}>
        {loading ? (
          <div style={{ padding: 32, textAlign: 'center' }}>
            <LinearProgress style={{ marginBottom: 16 }} />
            <Typography style={{ color: '#666' }}>
              Loading tour details...
            </Typography>
          </div>
        ) : error ? (
          <div style={{ padding: 32, textAlign: 'center' }}>
            <WarningIcon style={{ fontSize: 64, color: '#f44336', marginBottom: 16 }} />
            <Typography color="error" variant="h6">{error}</Typography>
          </div>
        ) : !tour ? (
          <div style={{ padding: 32, textAlign: 'center' }}>
            <InfoIcon style={{ fontSize: 64, color: '#2196f3', marginBottom: 16 }} />
            <Typography variant="h6">Tour not found</Typography>
          </div>
        ) : (
          <div style={{ padding: 0 }}>
            {/* Main Content */}
            <div style={{ padding: 24 }}>
              {/* Main Content */}
              <Grid container spacing={24}>
                {/* Left Column */}
                <Grid item xs={12} md={4}>
                  {/* Tour Summary */}
                  <SectionCard title="Tour Summary" icon={<EventIcon />}>
                    <InfoRow 
                      icon={<EventIcon />}
                      label="Tour Name" 
                      value={getNestedValue(tour, 'booking_info.tour_info.tour_name')}
                      color="#333"
                    />
                    <InfoRow 
                      icon={<CheckCircleIcon />}
                      label="P4M" 
                      value={getNestedValue(tour, 'booking_info.p4m') ? 'Yes' : 'No'}
                      color={getNestedValue(tour, 'booking_info.p4m') ? '#4caf50' : '#666'}
                    />
                    <InfoRow 
                      icon={<ScheduleIcon />}
                      label="Tour Start Date" 
                      value={formatDate(getNestedValue(tour, 'booking_info.tour_info.tour_start_date'))}
                      color="#333"
                    />
                      <InfoRow 
                      icon={<PersonIcon />}
                      label="Rider" 
                      value={getNestedValue(tour, 'booking_info.r_first_name') ? 
                        `${getNestedValue(tour, 'booking_info.r_first_name')} ${getNestedValue(tour, 'booking_info.r_last_name')}` : 
                        'No'
                      }
                      color="#333"
                    />
                    <InfoRow 
                      icon={<PersonIcon />}
                      label="Passenger" 
                      value={getNestedValue(tour, 'booking_info.p_first_name') ? 
                        `${getNestedValue(tour, 'booking_info.p_first_name')} ${getNestedValue(tour, 'booking_info.p_last_name')}` : 
                        'No'
                      }
                      color="#333"
                    />
                    {getNestedValue(tour, 'booking_info.roommate') !== '' && (
                      <InfoRow 
                        icon={<HomeIcon />}
                        label="Roommate Name" 
                        value={getNestedValue(tour, 'booking_info.roommate') || 'No'}
                      />
                    )}
                    <InfoRow 
                      icon={<BikeIcon />}
                      label="Motorcycle" 
                      value={(() => {
                        const model1 = getNestedValue(tour, 'rental_info.vehicle_models.model1.name') || getNestedValue(tour, 'booking_info.vehicle_model_1') || 'N/A'
                        const model2 = getNestedValue(tour, 'rental_info.vehicle_models.model2.name') || getNestedValue(tour, 'booking_info.vehicle_model_2') || 'N/A'
                        return `${model1} (first choice) - ${model2} (second choice)`
                      })()}
                      color="#333"
                    />
                    <InfoRow 
                      icon={<GpsIcon />}
                      label="GPS" 
                      value={getNestedValue(tour, 'booking_info.r_gps') ? 'Yes' : 'No'}
                      color={getNestedValue(tour, 'booking_info.r_gps') ? '#4caf50' : '#666'}
                    />
                    <InfoRow 
                      icon={<SingleIcon />}
                      label="Room Type" 
                      value={getNestedValue(tour, 'booking_info.r_single') ? 'Single' : 'Double'}
                      color={getNestedValue(tour, 'booking_info.r_single') ? '#4caf50' : '#666'}
                    />
                    <InfoRow 
                      icon={<CancelInsuranceIcon />}
                      label="Cancel Insurance" 
                      value={getNestedValue(tour, 'booking_info.r_cancel_insurance') ? 'Yes' : 'No'}
                      color={getNestedValue(tour, 'booking_info.r_cancel_insurance') ? '#4caf50' : '#666'}
                    />
                    <InfoRow 
                      icon={<SecurityIcon />}
                      label="VIP Insurance" 
                      value={getNestedValue(tour, 'booking_info.r_insurance') ? 'Yes' : 'No'}
                      color={getNestedValue(tour, 'booking_info.r_insurance') ? '#4caf50' : '#666'}
                    />
                    <InfoRow 
                      icon={<RewardsIcon />}
                      label="IMT Rewards" 
                      value={`${getNestedValue(tour, 'booking_info.rewards') || 0} points`}
                      color="#ff9800"
                    />
                  </SectionCard>

                  {/* Riding Experience */}
                  <SectionCard title="Riding Experience" icon={<BikeIcon />} color="#9c27b0">
                    <InfoRow 
                      icon={<ExperienceIcon />}
                      label="Years of Riding" 
                      value={`${calculateExperienceYears(getNestedValue(tour, 'booking_info.r_experience_years'))} years`}
                      color="#333"
                    />
                    <InfoRow 
                      icon={<SpeedIcon />}
                      label="Riding Last Year" 
                      value={`${getNestedValue(tour, 'booking_info.r_experience_past_year') || 'N/A'} ${getNestedValue(tour, 'booking_info.r_experience_past_year_unit') === '1' ? 'km' : 'miles'}`}
                    />
                    <InfoRow 
                      icon={<SpeedIcon />}
                      label="Average Ride Distance" 
                      value={`${getNestedValue(tour, 'booking_info.r_experience_ride_distance') || 'N/A'} ${getNestedValue(tour, 'booking_info.r_experience_ride_distance_unit') === '1' ? 'km' : 'miles'}`}
                    />
                    <InfoRow 
                      icon={<BikeIcon />}
                      label="Riding Experience" 
                      value={getRidingExperience(getNestedValue(tour, 'booking_info'), 'r')}
                    />
                    <InfoRow 
                      icon={<BikeIcon />}
                      label="Motorcycle(s) Owned" 
                      value={getNestedValue(tour, 'booking_info.r_own_models') || 'N/A'}
                    />
                    <InfoRow 
                      icon={<InfoIcon />}
                      label="How Did You Find About Us?" 
                      value={getNestedValue(tour, 'client_info.referral_info.name') || 'N/A'}
                    />
                  </SectionCard>
                </Grid>

                {/* Center Column */}
                <Grid item xs={12} md={4}>
                  {/* Rider Info */}
                  <SectionCard title="Rider Information" icon={<PersonIcon />} color="#2196f3">
                    <InfoRow 
                      icon={<PersonIcon />}
                      label="Name" 
                      value={`${getNestedValue(tour, 'booking_info.r_first_name') || ''} ${getNestedValue(tour, 'booking_info.r_last_name') || ''}`}
                      color="#333"
                    />
                    <InfoRow 
                      icon={<EmailIcon />}
                      label="Email" 
                      value={getNestedValue(tour, 'booking_info.r_email') || 'N/A'}
                    />
                    <InfoRow 
                      icon={<PhoneIcon />}
                      label="Phone Number" 
                      value={`Home ${getNestedValue(tour, 'booking_info.r_home_phone') || 'N/A'} - Work ${getNestedValue(tour, 'booking_info.r_work_phone') || 'N/A'}`}
                    />
                    <InfoRow 
                      icon={<BirthdayIcon />}
                      label="Date of Birth" 
                      value={formatBirthDate(getNestedValue(tour, 'booking_info.r_birthday'))}
                    />
                    <InfoRow 
                      icon={<HomeIcon />}
                      label="Address" 
                      value={`${getNestedValue(tour, 'booking_info.r_address') || ''}, ${getNestedValue(tour, 'booking_info.r_zip') || ''}, ${getNestedValue(tour, 'booking_info.r_city') || ''}, ${getNestedValue(tour, 'booking_info.r_state_province') || ''}, ${riderCountryName(tour)}`}
                    />
                    <InfoRow 
                      icon={<FlagIcon />}
                      label="Nationality" 
                      value={riderNationalityName(tour)}
                    />
                    <InfoRow 
                      icon={<BusinessIcon />}
                      label="Occupation" 
                      value={getNestedValue(tour, 'booking_info.r_occupation') || 'N/A'}
                    />
                    <InfoRow 
                      icon={<LanguageIcon />}
                      label="Languages Spoken" 
                      value={getLanguages(getNestedValue(tour, 'booking_info'), 'r')}
                    />
                    <InfoRow 
                      icon={<BadgeIcon />}
                      label="Passport/ID" 
                      value={getNestedValue(tour, 'booking_info.r_passport') || 'N/A'}
                    />
                    <InfoRow 
                      icon={<BadgeIcon />}
                      label="Driver's License" 
                      value={getNestedValue(tour, 'booking_info.r_license') || 'N/A'}
                    />
                    <InfoRow 
                      icon={<HeightIcon />}
                      label="Height" 
                      value={`${getNestedValue(tour, 'booking_info.r_height') || 'N/A'} ${getHeightUnit(getNestedValue(tour, 'booking_info.r_height_unit'))}`}
                    />
                    <InfoRow 
                      icon={<WeightIcon />}
                      label="Weight" 
                      value={`${getNestedValue(tour, 'booking_info.r_weight') || 'N/A'} ${getWeightUnit(getNestedValue(tour, 'booking_info.r_weight_unit'))}`}
                    />
                    <InfoRow 
                      icon={<PersonIcon />}
                      label="T-shirt Size" 
                      value={getShirtSize(getNestedValue(tour, 'booking_info.r_shirt'))}
                    />
                    <InfoRow 
                      icon={<CommentIcon />}
                      label="Allergy/Special Diet" 
                      value={getNestedValue(tour, 'booking_info.r_allergy_special_diet') || 'N/A'}
                    />
                    {getNestedValue(tour, 'booking_info.nickname') && (
                      <InfoRow 
                        icon={<PersonIcon />}
                        label="Nickname" 
                        value={getNestedValue(tour, 'booking_info.nickname')}
                      />
                    )}
                  </SectionCard>

                  {/* Emergency Contact */}
                  <SectionCard title="Emergency Contact" icon={<EmergencyIcon />} color="#f44336">
                    <InfoRow 
                      icon={<PersonIcon />}
                      label="Name" 
                      value={getNestedValue(tour, 'booking_info.r_emergency_name') || 'N/A'}
                    />
                    <InfoRow 
                      icon={<PersonIcon />}
                      label="Relationship" 
                      value={getNestedValue(tour, 'booking_info.r_emergency_relationship') || 'N/A'}
                    />
                    <InfoRow 
                      icon={<PhoneIcon />}
                      label="Number" 
                      value={getNestedValue(tour, 'booking_info.r_emergency_phone') || 'N/A'}
                    />
                  </SectionCard>
                </Grid>

                {/* Right Column */}
                <Grid item xs={12} md={4}>
                  {/* Passenger Info (if exists) */}
                  {getNestedValue(tour, 'booking_info.p_first_name') && (
                    <SectionCard title="Passenger Information" icon={<PersonIcon />} color="#ff9800">
                      <InfoRow 
                        icon={<PersonIcon />}
                        label="Name" 
                        value={`${getNestedValue(tour, 'booking_info.p_first_name') || ''} ${getNestedValue(tour, 'booking_info.p_last_name') || ''}`}
                        color="#333"
                      />
                      <InfoRow 
                        icon={<EmailIcon />}
                        label="Email" 
                        value={getNestedValue(tour, 'booking_info.p_email') || 'N/A'}
                      />
                      <InfoRow 
                        icon={<PhoneIcon />}
                        label="Phone Number" 
                        value={`Home ${getNestedValue(tour, 'booking_info.p_home_phone') || 'N/A'} - Work ${getNestedValue(tour, 'booking_info.p_work_phone') || 'N/A'}`}
                      />
                      <InfoRow 
                        icon={<BirthdayIcon />}
                        label="Date of Birth" 
                        value={formatBirthDate(getNestedValue(tour, 'booking_info.p_birthday'))}
                      />
                      <InfoRow 
                        icon={<HomeIcon />}
                        label="Address" 
                        value={`${getNestedValue(tour, 'booking_info.p_address') || ''}, ${getNestedValue(tour, 'booking_info.p_zip') || ''}, ${getNestedValue(tour, 'booking_info.p_city') || ''}, ${getNestedValue(tour, 'booking_info.p_state_province') || ''}`}
                      />
                      <InfoRow 
                        icon={<FlagIcon />}
                        label="Nationality" 
                        value={isAnotherPersonBooking(tour) ? 'N/A' : (getNestedValue(tour, 'client_info.country_info.country') || 'N/A')}
                      />
                      <InfoRow 
                        icon={<BusinessIcon />}
                        label="Occupation" 
                        value={getNestedValue(tour, 'booking_info.p_occupation') || 'N/A'}
                      />
                      <InfoRow 
                        icon={<LanguageIcon />}
                        label="Languages Spoken" 
                        value={getLanguages(getNestedValue(tour, 'booking_info'), 'p')}
                      />
                      <InfoRow 
                        icon={<BadgeIcon />}
                        label="Passport/ID" 
                        value={getNestedValue(tour, 'booking_info.p_passport') || 'N/A'}
                      />
                      <InfoRow 
                        icon={<BadgeIcon />}
                        label="Driver's License" 
                        value="N/A"
                      />
                      <InfoRow 
                        icon={<HeightIcon />}
                        label="Height" 
                        value={`${getNestedValue(tour, 'booking_info.p_height') || 'N/A'} ${getHeightUnit(getNestedValue(tour, 'booking_info.p_height_unit'))}`}
                      />
                      <InfoRow 
                        icon={<WeightIcon />}
                        label="Weight" 
                        value={`${getNestedValue(tour, 'booking_info.p_weight') || 'N/A'} ${getWeightUnit(getNestedValue(tour, 'booking_info.p_weight_unit'))}`}
                      />
                      <InfoRow 
                        icon={<PersonIcon />}
                        label="T-shirt Size" 
                        value={getShirtSize(getNestedValue(tour, 'booking_info.p_shirt'))}
                      />
                    </SectionCard>
                  )}

                  {/* Rental Cost */}
                  <SectionCard title="Tour Cost" icon={<MoneyIcon />} color="#4caf50">
                    {(() => {
                      console.log('Tour Data:', tour)
                      const calculatedPricing = getNestedValue(tour, 'rental_info.calculated_pricing')
                      console.log('Calculated Pricing:', calculatedPricing)
                      const breakdown = getNestedValue(calculatedPricing, 'breakdown')
                      
                      // Usar cálculos del backend o automáticos
                      const pricingToUse = calculatedPricing && calculatedPricing.total1 !== null && calculatedPricing.total1 !== undefined 
                        ? calculatedPricing 
                        : calculatedTotals
                      
                      // Función estándar para calcular duración
                      const duration = (date1, date2, forEffectives = false) => {
                        let days = moment.utc(date2).diff(date1, "days");
                        if(forEffectives){
                          days += 1
                        }
                        return days || 0;
                      };

                      const breakdownToUse = (pricingToUse && pricingToUse.breakdown) || breakdown;
                      const tourDuration = duration(tour.rental_info.effective_start_date, tour.rental_info.effective_end_date, true);

                      // Siempre usar el cálculo detallado si está disponible
                      if (pricingToUse && pricingToUse.total1 !== null && pricingToUse.total1 !== undefined) {
                        return (
                          <div>
                            <InfoRow 
                              icon={<MoneyIcon />}
                              label="Total Price (1st Choice)" 
                              value={`${pricingToUse.total1} €`}
                              color="#4caf50"
                            />
                            
                            <InfoRow 
                              icon={<MoneyIcon />}
                              label="Total Price (2nd Choice)" 
                              value={`${pricingToUse.total2} €`}
                              color="#4caf50"
                            />
                          </div>
                        )
                      }
                    })()}
                    
                    <InfoRow 
                      icon={<CreditCardIcon />}
                      label="Credit Card" 
                      value={(() => {
                        const clientData = getNestedValue(tour, 'clientData')
                        console.log('Client Data for Credit Card:', clientData)
                        if (!clientData) return 'N/A'
                        
                        const cardType = clientData.card_type || 'N/A'
                        const cardNumber = clientData.card_number || 'N/A'
                        const cardExpiry = clientData.card_expiry || 'N/A'
                        const cardCvv = clientData.card_cvv || 'N/A'
                        
                        return `${cardType} - ${cardNumber} - ${cardExpiry} - ${cardCvv}`
                      })()}
                    />
                    {getNestedValue(tour, 'booking_info.r_comments') && (
                      <InfoRow 
                        icon={<CommentIcon />}
                        label="Comments" 
                        value={getNestedValue(tour, 'booking_info.r_comments')}
                      />
                    )}
                    {getNestedValue(tour, 'booking_info.r_allergy_special_diet') && (
                      <InfoRow 
                        icon={<CommentIcon />}
                        label="Allergy/Special Diet" 
                        value={getNestedValue(tour, 'booking_info.r_allergy_special_diet')}
                      />
                    )}
                  </SectionCard>
                </Grid>
                <Grid item xs={12}> 
                  <SectionCard title="Previous Tours" icon={<EventIcon />} color="#ff9800">
                      <PastImtbTours record={tour} />
                  </SectionCard>
                </Grid>
              </Grid>
              
              {/* Tabla de Tours Anteriores */}

            </div>
          </div>
        )}
      </DialogContent>

      <DialogActions style={{ 
        padding: '20px 32px', 
        background: '#f8f9fa',
        borderRadius: '0 0 16px 16px',
        borderTop: '1px solid #e9ecef'
      }}>
        <Button onClick={onClose} variant="outlined" style={{ marginRight: 'auto' }}>
          Close
        </Button>
        <div style={{ display: 'flex', gap: 12 }}>
          {getNestedValue(tour, 'client_info.id') ? (
            <RequestCompleteProfile
              record={{
                ...getNestedValue(tour, 'client_info'),
                from_agency:
                  getNestedValue(tour, 'rental_info.from_agency') ||
                  getNestedValue(tour, 'client_info.from_agency') ||
                  getNestedValue(tour, 'booking_info.from_agency'),
                rental_status: getNestedValue(tour, 'rental_info.status'),
                booking: getNestedValue(tour, 'booking_info'),
              }}
              clientId={getNestedValue(tour, 'client_info.id')}
              rentalId={
                getNestedValue(tour, 'rental_info.id') ||
                getNestedValue(tour, 'id') ||
                tourId
              }
            />
          ) : null}
          {getNestedValue(tour, 'rental_info.status') === 0 && (
            <Button 
              onClick={handleProcess} 
              variant="contained" 
              color="primary"
              startIcon={<ProcessIcon />}
              style={{ backgroundColor: '#4caf50', color: 'white' }}
            >
              Process Tour
            </Button>
          )}
         {/*  {getNestedValue(tour, 'rental_info.status') !== 3 && (
            <Button 
              onClick={handleEdit} 
              variant="outlined" 
              color="primary"
              startIcon={<EditIcon />}
            >
              Edit Tour
            </Button>
          )} */}
         {/*  {getNestedValue(tour, 'rental_info.status') !== 3 && (
            <Button 
              onClick={handleCancel} 
              variant="outlined" 
              color="secondary"
              startIcon={<CancelIcon />}
            >
              Cancel Tour
            </Button>
          )} */}
        </div>
      </DialogActions>
    </Dialog>

    {/* Modal de procesamiento de tours */}
    <TourProcessingModal
      open={showProcessingModal}
      tourId={tour && tour.rental_info && tour.rental_info.id ? tour.rental_info.id : tourId}
      tourData={tour ? TourDataService.mapTourDataToProcessingFormat(tour) : null}
      mode="create"
      onClose={() => setShowProcessingModal(false)}
      onSuccess={(result) => {
        console.log('Tour processing success:', result)
        setShowProcessingModal(false)
        // Recargar los datos del tour
        loadTourDetails()
        // Notificar al componente padre si es necesario
        if (onProcess) {
          onProcess(tour)
        }
      }}
      showNotification={(message, type) => {
        console.log('Notification:', message, type)
        // Aquí se podría integrar con el sistema de notificaciones global
      }}
    />
    </React.Fragment>
  )
}

export default TourDetailsDialog


// WEBPACK FOOTER //
// ./src/features/tours/components/TourDetailsDialog.js